import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "config-layout" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "operation-bar" }
const _hoisted_5 = { key: 0 }

import { ref, reactive } from 'vue'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons-vue'
import SystemSideMenu from '@/components/SystemSideMenu.vue'

// 表格列定义

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthManager',
  setup(__props) {

const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '编码',
    dataIndex: 'code',
    key: 'code'
  },
  {
    title: '绑定账号',
    dataIndex: 'bindAccount',
    key: 'bindAccount'
  },
  {
    title: '绑定账号ID',
    dataIndex: 'bindAccountId',
    key: 'bindAccountId'
  },
  {
    title: 'IP白名单',
    dataIndex: 'ipWhitelist',
    key: 'ipWhitelist'
  },
  {
    title: '描述',
    dataIndex: 'description',
    key: 'description'
  },
  {
    title: '操作',
    key: 'action',
    width: 80
  }
]

// 表格数据
const dataSource = ref([])

// 分页配置
const pagination = {
  total: 0,
  current: 1,
  pageSize: 10,
  showTotal: (total: number) => `共 ${total} 条`
}

// 对话框显示控制
const modalVisible = ref(false)

// 表单数据
// 表单数据
const formState = reactive({
  code: '',
  bindUser: undefined,
  ipList: [''], // 初始化一个空的 IP 输入框
  autoGenerateKey: true,
  secretKey: '', // 新增密钥字段
  description: ''
})

// 显示新增对话框
const showAddModal = () => {
  modalVisible.value = true
}

// 添加新的 IP 输入框
const addNewIp = () => {
  formState.ipList.push('')
}

// 删除指定的 IP 输入框
const removeIp = (index: number) => {
  formState.ipList.splice(index, 1)
}

// 确认提交
const handleModalOk = () => {
  // 处理表单提交逻辑
  console.log('表单数据：', formState)
  modalVisible.value = false
}

// 取消提交
const handleModalCancel = () => {
  modalVisible.value = false
  // 重置表单数据
  formState.code = ''
  formState.bindUser = undefined
  formState.ipList = [''] 
  formState.autoGenerateKey = true
  formState.secretKey = '' // 重置密钥
  formState.description = ''
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, { bordered: false }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: showAddModal
              }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode("新增认证")
                ])),
                _: 1
              })
            ]),
            _createVNode(_component_a_table, {
              columns: columns,
              "data-source": dataSource.value,
              pagination: pagination
            }, {
              bodyCell: _withCtx(({ column }) => [
                (column.key === 'action')
                  ? (_openBlock(), _createElementBlock("a", _hoisted_5, "编辑"))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["data-source"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: modalVisible.value,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((modalVisible).value = $event)),
      title: "新增开放认证",
      onOk: handleModalOk,
      onCancel: handleModalCancel,
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: formState,
          "label-col": { span: 6 },
          "wrapper-col": { span: 16 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "自定义编码",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: formState.code,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.code) = $event)),
                  placeholder: "请输入自定义编码"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "绑定权限用户",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: formState.bindUser,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.bindUser) = $event)),
                  placeholder: "请输入绑定权限用户",
                  "show-search": ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "IP白名单" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formState.ipList, (ip, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "ip-input-row"
                  }, [
                    _createVNode(_component_a_input, {
                      value: formState.ipList[index],
                      "onUpdate:value": ($event: any) => ((formState.ipList[index]) = $event),
                      placeholder: "请输入 IP 地址"
                    }, null, 8, ["value", "onUpdate:value"]),
                    _createVNode(_component_a_button, {
                      type: "link",
                      danger: "",
                      onClick: ($event: any) => (removeIp(index)),
                      class: "remove-btn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(DeleteOutlined))
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]))
                }), 128)),
                _createVNode(_component_a_button, {
                  type: "link",
                  class: "add-ip-btn",
                  onClick: addNewIp
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(PlusOutlined)),
                    _cache[7] || (_cache[7] = _createTextVNode(" 添加新IP白名单 "))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "秘钥自动生成" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_switch, {
                  checked: formState.autoGenerateKey,
                  "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((formState.autoGenerateKey) = $event))
                }, null, 8, ["checked"])
              ]),
              _: 1
            }),
            (!formState.autoGenerateKey)
              ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "密钥"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: formState.secretKey,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((formState.secretKey) = $event)),
                      placeholder: "请输入密钥"
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form_item, { label: "描述" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: formState.description,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((formState.description) = $event)),
                  placeholder: "请输入描述",
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})